export const ROUTES = {
  dashboard: '/dashboard',
  distributors: '/distributors',
  distributor: (id: string) => `/distributors/${id}`,
  resellers: '/resellers',
  reseller: (id: string) => `/resellers/${id}`,
  licenseProducts: '/license-products',
  distributorLicenses: '/licenses/distributor',
  resellerLicenses: '/licenses/reseller',
  deviceLicenses: '/devices',
  deviceLicense: (id: string) => `/devices/${id}`,
  reportsPools: '/reports/pool-availability',
  reportsCapacity: '/reports/reseller-capacity',
  reportsExpiring: '/reports/expiring-devices',
  reportsDeviceInstallation: '/reports/device-installation',
  reportsDeviceLockUnlock: '/reports/device-lock-unlock',
  iamUsers: '/iam/users',
  iamRoles: '/iam/roles',
  iamTenants: '/iam/tenants',
}
